import React from "react";
import  { withStyles } from  '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import Iframe from 'react-iframe'

const styles = theme => ({
  root: {
    marginRight: theme.spacing.unit,
  }
})


@inject("authStore", "commonStore")
@observer
class Blog extends React.Component {
  constructor(props, context) {
    super(props, context);
        this.state = {

        }
    }
  componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
      }
      componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
      }
    
  updateWindowDimensions = () => {
    // document.removeEventListener('keydown', this.onKeydown);
    const width = window.innerWidth;
    const height = window.innerHeight;

    this.setState({ height, width });
  }
render(){
    const { classes, commonStore, url } = this.props
    const { width, height } = this.state

    if(!url){
        return null
    }

    return (
        <div className={classes.root} style={{width, height }}>
        <Iframe url={url}
        width={`${97}%`}
        height={`${height}px`}
        id={'board'}
        display="initial"
        allowFullScreen/>
        </div>
    )

}

}

export default withStyles(styles)(Blog);


// WEBPACK FOOTER //
// ./src/components/Leads/Blog/index.js